const apiClientId = process.env.REACT_APP_API_CLIENT_ID;

export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_CLIENT_ID,
    clientSecret:
      process.env.REACT_APP_CLIENT_SECRET,
    authority: 'https://login.microsoftonline.com/organizations',
    redirectUri: process.env.REACT_APP_LOGIN_REDIRECT_URI,
  },
  cache: {
    cacheLocation: 'sessionStorage',
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: [`api://${apiClientId}/Api.ReadWrite`],
};
